// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"c98b89cb","516":"85bee19b","668":"c98b89cb"}[chunkId] + ".chunk.css";
};